module.exports = __webpack_public_path__ + "static/img/setQuickSmsType.703915c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smsSetting/setQuickSmsType.png
// module id = U3U8
// module chunks = 0